import {compose, applyMiddleware} from 'redux';

// Enhancer functions from
import thunkMiddleware from './thunk';
import crudLogger from './crudLogger';

// This line is to add support fro redux devtools if installed
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const middlewares =  [
    thunkMiddleware,
    crudLogger
];

export default () => {
    return composeEnhancers(
        applyMiddleware(...middlewares)
    );
}